let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e9K7A")).then(() => parcelRequire('itO8c'));